import PageHero from "../components/PageHero";
import About from "../components/sections/About";
import { CALENDLY_URL } from "../lib/site";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About"
        accent="#FF007F"
        title={
          <>
            Built by educators, makers and{" "}
            <span className="bg-[#00C2B8] px-2 inline-block">creative</span>{" "}
            industry thinkers.
          </>
        }
        intro="TinkerShift was created to help organisations move from talking about future-ready learning to actually building it."
        ctaLabel="Meet with Julija"
        ctaTo={CALENDLY_URL}
        ctaExternal
      />
      <About />
    </div>
  );
}
